import { useContext, useEffect, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import { getSibling } from 'store/slices/userSlice';
import { AuthContext } from 'utils/AuthContext';
import { SiblingProfile, findActiveSibling } from './siblingProfile';

/**
 * MM-1123: loads the guardian's sibling list (read only) for screens outside the header, such as the
 * dashboard greeting and the login profile picker. The header keeps its own fetch, which also
 * resolves user.patientId after sign-in.
 *
 * @returns the siblings, the one currently open, and whether the list has loaded.
 */
export const useSiblings = () => {
  const dispatch = useAppDispatch();
  const { user } = useContext(AuthContext);
  /** Sibling list from GET_SIBLING; undefined until loaded. */
  const [siblings, setSiblings] = useState<SiblingProfile[]>();

  useEffect(() => {
    if (user?.isAdmin === true) {
      return;
    }
    if (user?.patientId === undefined) {
      return;
    }
    dispatch(getSibling({}))
      .unwrap()
      .then((response: any) => {
        if (response?.status === 200) {
          setSiblings(response?.data ?? []);
        }
      })
      .catch(() => setSiblings([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.patientId]);

  return {
    siblings,
    activeSibling: findActiveSibling(siblings, user?.patientId),
    loaded: siblings !== undefined,
  };
};
